export default "__VITE_ASSET__2281d4ba__"